import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AdminService } from '@app/services/admin.service';
import { CommonService } from '@app/shared-module/common-service.service';
import { Constants } from '@app/shared-module/constants';
import { GlobalResponse, User } from '@app/shared-module/models';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { UpdateDoctorSubscriptionDialogComponent } from '../update-doctor-subscription/update-doctor-subscription.component';
import { UpdateMaxDoctorDialogComponent } from '../update-max-doctor/update-max-doctor.component';
import { ViewDoctorSubscriptionDialogComponent } from '../view-doctor-subscription/view-doctor-subscription.component';
import { HardResetPasswordComponent } from '@app/admin-module/hard-reset-password/hard-reset-password.component';

@Component({
  selector: 'app-subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.scss'],
})
export class SubscriptionListComponent implements OnInit {
  user: User;
  isEditEnabled = false;
  subscriptionList: any[] = [];
  // subscriptionCount = 0;
  length = 0;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    private adminSrv: AdminService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public commonService: CommonService
  ) {}

  ngOnInit() {
    this.user = this.commonService.internalLoginValue;
    this.fetchSubscriptionList();
    if (
      this.user &&
      this.user.role &&
      (this.user.role === Constants.ROLE_ADMIN ||
        this.user.role === Constants.ROLE_MARKETING)
    ) {
      this.isEditEnabled = true;
    } else {
      this.isEditEnabled = false;
    }
  }

  fetchSubscriptionList() {
    this.blockUI.start();
    this.adminSrv
      .getDoctorSubscriptions(this.pageSize, this.pageNumber)
      .subscribe(
        (res: GlobalResponse) => {
          this.blockUI.stop();
          if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
            this.subscriptionList = res.result.doctorSubscription;
            // this.subscriptionCount = res.result.doctorSubscriptionCount;
            this.length = res.result.doctorSubscriptionCount;
          }
        },
        (error: any) => {
          this.toastr.error(error);
        }
      );
  }

  pageEvent(event) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchSubscriptionList();
  }

  viewSubscription(item) {
    let subscriptionData: any;
    this.blockUI.start();
    this.adminSrv
      .fetchDoctorSubscriptionsDetails(item._id)
      .subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          subscriptionData = res.result;
          const viewDocSubscription = this.dialog.open(
            ViewDoctorSubscriptionDialogComponent,
            {
              disableClose: false,
            }
          );
          viewDocSubscription.componentInstance.headerTitle =
            'View Subscription';
          viewDocSubscription.componentInstance.subscriptionData =
            subscriptionData;
          viewDocSubscription.componentInstance.doctor_id = item._id;
          viewDocSubscription.afterClosed().subscribe((result) => {
            if (result) {
              this.fetchSubscriptionList();
            }
          });
        }
      });
  }

  resetPassword() {
      const resetPasswordDialog = this.dialog.open(HardResetPasswordComponent, {
        disableClose: false
      });
      resetPasswordDialog.afterClosed().subscribe(result => {
        if (result) {
          this.fetchSubscriptionList();
        }
        // this.addInternalUser = null;
      });
    }

  editSubscription(item: any) {
    let subscriptionData: any;
    this.blockUI.start();
    this.adminSrv
      .fetchDoctorSubscriptionsDetails(item._id)
      .subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          subscriptionData = res.result;
          const editDocSubscription = this.dialog.open(
            UpdateDoctorSubscriptionDialogComponent,
            {
              disableClose: false,
            }
          );
          editDocSubscription.componentInstance.headerTitle =
            'Edit Subscription';
          editDocSubscription.componentInstance.subscriptionData =
            subscriptionData;
          editDocSubscription.componentInstance.doctor_id = item._id;
          editDocSubscription.afterClosed().subscribe((result) => {
            if (result) {
              this.fetchSubscriptionList();
            }
          });
        }
      });
  }

  editMaxDoctor(item: any) {
    const updateMaxDoc = this.dialog.open(UpdateMaxDoctorDialogComponent, {
      disableClose: false,
    });

    // this.updateMaxDoc.componentInstance.subscriptionData = subscriptionData;
    updateMaxDoc.afterClosed().subscribe((result) => {
      if (result) {
        this.blockUI.start();
        this.adminSrv.updateMaxDoctor(result, item._id).subscribe(
          (res: GlobalResponse) => {
            this.blockUI.stop();
            if (
              res &&
              res.message &&
              res.message === Constants.STATUS_SUCCESS
            ) {
              this.fetchSubscriptionList();
            }
          },
          (error) => {
            this.blockUI.stop();
            this.toastr.error(Constants.LABEL_ERROR, error);
          }
        );
      }
    });
  }

  exportAsXLSX(): void {
    const header = {
      header: [
        'Doctor',
        'Clinic',
        'Trial End Period',
        'Plan',
        'Payment Date',
        'Amount Paid',
        'Subscription End Date',
        'Active Doctors',
        'Max Doctors',
      ],
    };
    const tempArray = [];
    for (const item of this.subscriptionList) {
      const tempItem: any = {} as any;
      if (
        item.clinics[0] &&
        item.clinics[0].clinic &&
        item.clinics[0].clinic.name
      ) {
        tempItem.clinic = item.clinics[0].clinic.name;
      } else {
        continue;
      }
      tempItem.doctor = item.doctor.first_name + item.doctor.last_name;

      tempItem.plan = item.plan.name;
      tempItem.payment_date = this.datePipe.transform(
        item.payment_details.payment_date,
        'yyyy-MM-dd'
      );
      tempItem.paid_amount = item.paid_amount;
      tempItem.trail_period_start = item.trail_period_start;
      tempItem.trail_period_end = item.trail_period_end;
      tempItem.subscription_start = item.subscription_start;
      tempItem.subscription_end = item.subscription_end;
      tempItem.status = item.status;
      tempItem.active_doctors = item.active_doctors;
      tempItem.max_doctors = item.max_doctors;
      tempArray.push(tempItem);
    }
    this.commonService.exportAsExcelFile(tempArray, header, 'subsctiption');
    // this.commonService.exportTemplateAsExcel(tempArray, header);
  }
}
